import Api from '@/services/Api'
import GmwApi from '@/services/GmwApi'

export default {
    getall () {
        return Api().get('vendor/getall')
    },


    //GMW
    getallgmw () {
        return GmwApi().get('vendor/getall')
    },
}